module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./NewsView.js"));
	}, "NewsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NewsView!./src/pages/Shop/Home/News/NewsView.js
// module id = 932
// module chunks = 431